import moment from 'moment';
import _ from 'lodash';
import { isStringNotNull } from '../../utils/tools';
import { TableOrderProp } from './Table.view';

const descendingComparator = (a: Record<string, any>, b: Record<string, any>, orderBy: string) => {  
  if (moment(b[orderBy]).isValid()) return moment(b[orderBy]).valueOf() - moment(a[orderBy]).valueOf();

  if (typeof b[orderBy] === 'number' || typeof b[orderBy] === 'boolean') {
    return Number(a[orderBy]) - Number(b[orderBy]);
  }

  if (isStringNotNull(b[orderBy]) && typeof b[orderBy] === 'string') {    
    return b[orderBy].localeCompare(a[orderBy], undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }
  return 0;
};

export const getComparator = (order: TableOrderProp, orderBy: string): ((a: any, b: any) => number) => {
  return order === 'desc'
    ? (a: Record<string, any>, b: Record<string, any>) => descendingComparator(a, b, orderBy)
    : (a: Record<string, any>, b: Record<string, any>) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (data, comparator) => {  
  const sortArray = _.map(data, (el, index) => [{ ...el, key: index }, index]);
  sortArray.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return sortArray.map(el => el[0]);
};